import type { ComponentInfo } from "@builder.io/sdk-react";

import { PRODUCT_ATTRIBUTE_CODES } from "@jti/commerce/features";

const ATTRIBUTE_CODE_OPTIONS = [
  { label: "Strength", value: PRODUCT_ATTRIBUTE_CODES.strength },
  { label: "Flavor Family", value: PRODUCT_ATTRIBUTE_CODES.flavorFamily },
  { label: "Pouch Size", value: PRODUCT_ATTRIBUTE_CODES.pouchSize },
  { label: "Experience", value: PRODUCT_ATTRIBUTE_CODES.experience },
  { label: "Formula", value: PRODUCT_ATTRIBUTE_CODES.formula },
];

export const ATTRIBUTE_FILTERS_DRAWER_INPUTS = [
  {
    name: "filterSections",
    type: "list",
    helperText:
      "Configure the drawer filter sections. Select the Magento attribute for each section. The order here is the order shown in the drawer; the first section opens expanded. Option values come from the catalogue automatically. Each attribute can only be added once.",
    subFields: [
      {
        name: "attributeCode",
        friendlyName: "Attribute",
        type: "string",
        enum: ATTRIBUTE_CODE_OPTIONS,
        required: true,
      },
    ],
    defaultValue: [],
  },
] as const satisfies ComponentInfo["inputs"];

export type AttributeFiltersInputs = BuilderComponentProps<typeof ATTRIBUTE_FILTERS_DRAWER_INPUTS>;
